<template>
  <master-layout pageTitle="Team">
    <BackButton variant="inline" @click="backButton" />
    <div class="w-full">
      <div v-html="teamPage.htmlPage"></div>
    </div>
  </master-layout>
</template>

<script>
import platformMixin from '@/mixins/platformMixin';
import { mapState } from 'vuex';
import { FirebaseAnalytics } from '@/utils/firebase-analytics-wrapper';
import BackButton from '@/components/common/BackButton.vue';
import axios from 'axios';

export default {
  name: 'TeamPage',
  components: { BackButton },
  mixins: [platformMixin],
  data() {
    return {
      teamPage: {
        htmlPage: '',
      },
    };
  },
  computed: {
    ...mapState('user', ['token']),
  },
  async ionViewDidEnter() {
    FirebaseAnalytics.setScreenName({
      screenName: 'team',
      nameOverride: 'TeamPage',
    });
    await this.fetchTeamPage();
  },
  methods: {
    backButton() {
      // Use real history when it exists; fall back to Home when opened fresh
      // (deep link / no history to pop).
      if (window.history.state?.back) {
        this.$router.back();
      } else {
        this.$router.push('/home');
      }
    },
    async fetchTeamPage() {
      const { data } = await axios.get(process.env.VUE_APP_API_URL + '/cms/team-page', {
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      });
      this.teamPage = data;
    },
  },
};
</script>
